export default __webpack_public_path__ + "static/media/Vist .ai.02d2a8dd.svg";